var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "customer" },
    [
      _c("cc-loading-box", {
        staticClass: "loading-box",
        attrs: { isLoading: _vm.isLoading }
      }),
      _c(
        "div",
        { staticClass: "oprAndBrand" },
        [
          _c(
            "Modal",
            {
              attrs: { width: "500px", closable: false, maskClosable: false },
              model: {
                value: _vm.isOprShow,
                callback: function($$v) {
                  _vm.isOprShow = $$v
                },
                expression: "isOprShow"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "choose-modal-title",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("请选择运营商")]
              ),
              _c(
                "ul",
                _vm._l(_vm.oprList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "item",
                      class: _vm.oprIndex === index ? "checked" : "",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.checkPlat(item, index)
                        },
                        dblclick: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.dbClickPlat(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.platformName) +
                          "\n        "
                      )
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "am-text-right",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "cc-button",
                    {
                      attrs: { type: "primary", disabled: _vm.oprIndex < 0 },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sureOpr.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "Modal",
            {
              attrs: { width: "500px", closable: false, maskClosable: false },
              model: {
                value: _vm.isBrandShow,
                callback: function($$v) {
                  _vm.isBrandShow = $$v
                },
                expression: "isBrandShow"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "choose-modal-title",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [_vm._v("请选择品牌")]
              ),
              _c(
                "ul",
                _vm._l(_vm.brandList, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "item",
                      class: _vm.brandIndex === index ? "checked" : "",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.checkBrand(item, index)
                        },
                        dblclick: function($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.dbClickBrand(item)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " + _vm._s(item.brandName) + "\n        "
                      )
                    ]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "am-text-right",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "cc-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.backOpr.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("上一步")]
                  ),
                  _c(
                    "cc-button",
                    {
                      attrs: { type: "primary", disabled: _vm.brandIndex < 0 },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.sureBrand.apply(null, arguments)
                        }
                      }
                    },
                    [_vm._v("下一步")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-67a54450", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67a54450","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/choose.vue
// module id = mSub
// module chunks = 5